const endpoint = (process.env.NODE_ENV === 'developmentx')
  ? 'http://localhost:3000/app'
  : 'https://api.lcy.inncom.cloud/app';

// const endpoint = 'http://localhost:3000/app';

export default {
  auth: `${endpoint}/auth`,
  member: {
    login: `${endpoint}/member/login`,
    logout: `${endpoint}/member/logout`,
    accountRecovery: `${endpoint}/member/account-recovery`,
    password: `${endpoint}/member/password`,
    clinic: `${endpoint}/member/clinic`,
  },
  membership: `${endpoint}/membership`,
  appointments: `${endpoint}/appointments`,
  introductions: `${endpoint}/introductions`,
  motheringClasses: `${endpoint}/mothering-classes`,
  doctors: `${endpoint}/doctors`,
  schedulePictures: `${endpoint}/schedule-pictures`,
  schedules: `${endpoint}/schedules`,
  feedbacks: `${endpoint}/feedbacks`,
  hibaby: `${endpoint}/hibaby`,
  satisfactionSurveys: `${endpoint}/satisfaction-surveys`,
  inboxes: `${endpoint}/inboxes`,
  progress: `${endpoint}/progress`,
  progressReminders: `${endpoint}/progress-reminders`,
};
